import React, { Component } from 'react'
import ReactFileReader from 'react-file-reader';
import { PatchFilesAxios } from '../../axiosComponent/postFilesAxios';
import { Dimmer, Loader, Dropdown, Button, Modal, Table, Divider, Form, Grid, Input, Icon, Image, TextArea } from 'semantic-ui-react';
import moment from 'moment';
import ReadAxios from '../../axiosComponent/commanReadAxios';
import ReadAxiosM from '../../axiosComponent/read';
import Axios from 'axios';
import { MyNormalInput } from '../../dynamicComponent/myInputs';
import cogoToast from 'cogo-toast';
import PdfAxios from '../../axiosComponent/downloadpdf';
import APP_CONSTANT from '../../../config/config'
export default class ViewPod extends Component {
    state = {
        pod_view_info: [],
        reasons: [],
        recipient_name: '',
        driver_name: this.props.driverName,
        delivery_reason: '',
        entity: '',
        id: '',
        change_recipient: false,
        change_quantity: false,
        is_updated: false,
        change_reason: false,
        uploadPercent: false,
        shortageQuantity: '',
        shortageReason: '',
        damageQuantity: '',
        damageReason: '',
        excessQuantity: "",
        excessReason: "",
    }

    getData = () => {
        let podInfo = this.props.delivery ? this.props.delivery : ''
        var gett = localStorage.getItem('isloggedIn');
        var customerNo = localStorage.getItem('customerNumber');
        var userId = localStorage.getItem('userId');
        let congData = JSON.stringify
            ({
                customerNumber: customerNo,
                userId: userId,
                userKey: this.props.auth.userKey,
                req_type: "non_userkey",
                deliveryNo: this.props.delivery ? this.props.delivery.delivery_no : podInfo.delivery_no,
                orderNo: this.props.orders.order_no,
                delivery_reason: this.props.deliveryNotes,
            })
        Axios.post(`${process.env.REACT_APP_BASE_COMMON}/pod/podDetails`, congData,
            { headers: { 'content-type': 'application/json', 'Authorization': `${gett}` } })
            .then((res) => {
                // console.log('View PoD', res.data.resultSet)
                this.setState({
                    pod_view_info: res.data.resultSet,
                    recipient_name: res.data.resultSet[0].recipientName,
                    driver_name: res.data.resultSet[0].driverName ? res.data.resultSet[0].driverName : this.props.driverName,
                    id: res.data.resultSet[0].deliveryDetailId,
                    delivery_reason: res.data.resultSet[0].deliveryNotes,
                    shortageQuantity: res.data.resultSet[0].shortageQuantity,
                    shortageReason: res.data.resultSet[0].shortageReasonId,
                    damageQuantity: res.data.resultSet[0].damageQuantity,
                    damageReason: res.data.resultSet[0].damageReasonId,
                    excessQuantity: res.data.resultSet[0].excessQuantity,
                    excessReason: res.data.resultSet[0].excessReasonId,
                    is_updated: false,
                    uploadPercent: false,
                })
            })

    }
    getReasons = () => {
        ReadAxiosM({ url: `/shortageDamageReasonMaster/` })
            .then((result) => {
                this.setState({ reasons: result.data.resultSet })
            })
    }
    componentDidUpdate() {
        if (this.state.is_updated) {
            console.log("The component got updated")
            this.getData()
        }
    }
    componentDidMount() {
        this.getData()
        this.getReasons()
        // console.log('VIEW', this.props.auth.userKey)
    }

    handleFiles = (files, name) => {
        console.log(files.fileList[0])
        let data = {
            documentContent: files.fileList[0],
            documentName: name,
            orderNo: this.props.orders.order_no ? this.props.orders.order_no : "",
            deliveryNo: this.props.deliveryDetails ? this.props.deliveryDetails[0].delivery_no : "",
        };
        PatchFilesAxios({
            //url: `pod/podDetails/delivery_primary`,
            url: `pod/document`,
            createItems: data,

        })
            .then((res) => {

                cogoToast.success('Uploaded Success').then(() => {
                    this.setState({ is_updated: true })
                });

            })
            .catch((err) => { console.log(err); cogoToast.error(err); })

        // let pdf = files.base64.split(',');
        // let id = this.state.id
        // let key = 'deliveryImage'
        // let order = this.props.orderNumber
        // let delivery = this.props.podInfo[0].delivery_no
        // this.getUpdate(id, key, order, delivery, pdf[1])
    }


    handleGoods = (files, e) => {
        // console.log('>>>', files, e)
        let pdf = files.base64.split(',');
        let id = this.state.id
        let key = 'customerInvoice'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, pdf[1])
    }
    handleVendor = (files, e) => {
        // console.log('>>>', files, e)
        let pdf = files.base64.split(',');
        let id = this.state.id
        let key = 'vendorInvoice'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, pdf[1])
    }
    handleDataLogger = (files, e) => {
        // console.log('>>>', files, e)
        let pdf = files.base64.split(',');
        let id = this.state.id
        let key = 'dataLogger'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, pdf[1])
    }
    handleChange = (e) => {
        let value = e.target.value;
        let name = e.target.name
        if (name === 'recipient_name') {
            this.setState({
                recipient_name: value,
                entity: value,
                change_recipient: true
            })
        }
        if (name === 'driverName') {
            this.setState({
                driver_name: value,
                entity: value,
                change_quantity: true
            })
        }
        if (name === 'deliveryNotes') {
            this.setState({
                delivery_reason: value,
                entity: value,
                change_reason: true
            })
        }
        if (name === 'shortageQuantity') {
            this.setState({
                shortageQuantity: value,
                entity: value,
                change_reason: true
            })
        }
        if (name === 'shortageReason') {
            this.setState({
                shortageReason: value,
                entity: value,
                change_reason: true
            })
        }
        if (name === 'damageQuantity') {
            this.setState({
                damageQuantity: value,
                entity: value,
                change_reason: true
            })
        }
        if (name === 'damageReason') {
            this.setState({
                damageReason: value,
                entity: value,
                change_reason: true
            })
        }
        if (name === 'excessQuantity') {
            this.setState({
                excessQuantity: value,
                entity: value,
                change_reason: true
            })
        }
        if (name === 'excessReason') {
            this.setState({
                excessReason: value,
                entity: value,
                change_reason: true
            })
        }
    }
    handleDropdown = (e, data) => {
        // console.log(data.value)
        if (data.name === 'shortageReason') {
            this.setState({
                shortageReason: data.value,
                entity: data.value
            })
        }
        if (data.name === 'damageReason') {
            this.setState({
                damageReason: data.value,
                entity: data.value
            })
        }
        if (data.name === 'excessReason') {
            this.setState({
                excessReason: data.value,
                entity: data.value
            })
        }
    }
    handleShipment = (files) => {
        let img = files.base64;
        let id = this.state.id
        let key = 'shipmentImage'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, img)
    }
    handleSign = (files) => {
        let img = files.base64;
        let id = this.state.id
        let key = 'signatureImage'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, img)
    }
    handleAgent = (files) => {
        let img = files.base64;
        let id = this.state.id
        let key = 'deliveryAgentSelfie'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, img)
    }
    handleRecipient = (files) => {
        let img = files.base64;
        let id = this.state.id
        let key = 'recipientImage'
        let order = this.props.orders.order_no
        let delivery = this.props.deliveryDetails[0].delivery_no
        this.getUpdate(id, key, order, delivery, img)
    }
    view = (e) => {
        let path = `${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem('customerNumber')}&deliveryNumber=${e.currentTarget.dataset.deliveryno}&orderNo=${e.currentTarget.dataset.orderno}&resource_url=${e.currentTarget.dataset.pod}&rak=${e.currentTarget.dataset.rak}`
        window.open(path, "_blank");
        // console.log(e.currentTarget.dataset);
    }
    upload = (e) => {
        let id = e.currentTarget.dataset.id
        let key = e.currentTarget.dataset.key
        let order = e.currentTarget.dataset.order
        let delivery = e.currentTarget.dataset.delivery
        let value = this.state.entity
        // console.log(id, key, order, delivery, value)
        this.getUpdate(id, key, order, delivery, value)
    }
    download = (e) => {

        let path = `${process.env.REACT_APP_BASE_COMMON
            }/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem(
                "customerNumber"
            )}&deliveryNumber=${e.currentTarget.dataset.deliveryno}&orderNo=${e.currentTarget.dataset.orderno
            }&resource_url=${e.currentTarget.dataset.pod}&rak=${e.currentTarget.dataset.rak
            }`
        PdfAxios({
            PDFURL: path,
        })
            .then((res) => {
            })
            .catch((err) => {
                console.log(err);
            });
    }
    getUpdate = (id, key, order, delivery, value) => {
        this.setState({ uploadPercent: true })
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
        let updateItems = JSON.stringify
            ({
                customerNo: customerNo,
                customerNumber: customerNo,
                userId: userId,
                orderNo: order,
                deliveryNo: delivery,
                data: value
            })
        Axios.patch(`${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/delivery_primary/${id}?entity=${key}`, updateItems, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `${localStorage.getItem('isloggedIn')}`
            }
        }).then((response) => {
            if (response.data.status === 200) {
                cogoToast.success(response.data.message)
                this.setState({
                    change_recipient: false,
                    change_quantity: false,
                    change_reason: false,
                    is_updated: true
                })
            }
        })
    }
    render() {
        let options = []
        if (this.state.reasons.length > 0) {
            this.state.reasons.map((object, index) => {
                let temp = {}
                temp.key = object.reasonId
                temp.text = object.reasonDescription
                temp.value = object.reasonId
                return options[index] = temp
            })
        }
        let defaultImage = 'https://react.semantic-ui.com/images/wireframe/white-image.png'
        return (
            <div>
                <Modal open={this.props.viewPod} onClose={this.props.viewPodModalClose}>
                    <Modal.Header>POD Details</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Table className="w3-small">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="4" className="text-left w3-white w3-text-blue">Invoice Details</Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell className="text-left">Invoice Number</Table.HeaderCell>
                                        <Table.HeaderCell className="text-left">Tracking Number</Table.HeaderCell>
                                        <Table.HeaderCell className="text-left">Invoice Date</Table.HeaderCell>
                                        <Table.HeaderCell className="text-left">Invoice Quantity</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.props?.deliveryDetails && this.props.deliveryDetails.length > 0 ?
                                        this.props.deliveryDetails.map((object, index) => (
                                            <>
                                                {object?.invoices && object.invoices.length > 0 ?

                                                    object.invoices.map((obj, i) => {
                                                        return (<Table.Row>
                                                            <Table.Cell>{obj.invoice_no}</Table.Cell>
                                                            <Table.Cell>{obj.tracking_number}</Table.Cell>
                                                            <Table.Cell>{moment(obj.invoice_date).format('DD-MM-YYYY')}</Table.Cell>
                                                            <Table.Cell>{obj.invoice_quantity}</Table.Cell>
                                                        </Table.Row>
                                                        )
                                                    })
                                                    : ''}
                                            </>
                                        )) : ''}
                                </Table.Body>
                            </Table>
                            <Divider horizontal>
                                <label className="p-bold-600 w3-text-blue">Basic Details</label>
                            </Divider>
                            {this.state.pod_view_info.map((pod, index) => (
                                <>
                                    {console.log("State of POD View Info", this.state.pod_view_info)}
                                    <Dimmer active={this.state.uploadPercent} inverted>
                                        <Loader inverted>Loading...</Loader>
                                    </Dimmer>
                                    <Grid columns="3" padded>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <label>Delivery Number *</label> <br />
                                                <div className="field">
                                                    <div className="ui input">
                                                        <input readOnly name="delivery_no"
                                                            value={pod.deliveryNo}
                                                        />
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Driver Name</label> <br />
                                                <div className="field">
                                                    <div className="ui input">
                                                        <input onChange={this.handleChange} name="driverName" value={this.state.driver_name} />
                                                        <button hidden={!this.state.change_quantity} onClick={this.upload} data-key="driverName"
                                                            data-id={pod.deliveryDetailId}
                                                            data-delivery={pod.deliveryNo}
                                                            data-order={pod.orderNo}
                                                            className="btn border">
                                                            <i className="fas fa-check"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Recipient Name *</label> <br />
                                                <div className="field">
                                                    <div className="ui input">
                                                        <input onChange={this.handleChange} name="recipient_name" value={this.state.recipient_name} />
                                                        <button hidden={!this.state.change_recipient} onClick={this.upload} data-key="recipientName" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                            <i className="fas fa-check"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    <Divider horizontal>
                                        <label className="p-bold-600 w3-text-blue">PoD</label>
                                    </Divider>
                                    <Grid columns="2" padded>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <label>LR Front *</label> <br />
                                                <div className="input-group-append">
                                                    <Button onClick={this.view} data-key="podView"
                                                        data-deliveryNo={pod.deliveryNo} data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK} data-pod={pod.deliveryImagePath} className="w3-button w3-round w3-tiny w3-white w3-hover-text-green w3-text-green w3-border w3-hover-white"><i className="fas fa-eye" /></Button>
                                                    <ReactFileReader base64={true} fileTypes={[".pdf"]} handleFiles={(files) => { this.handleFiles(files, "deliveryImage") }}>
                                                        <Button type="button" className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white">
                                                            <i className="fas fa-upload"></i>
                                                        </Button>
                                                    </ReactFileReader>
                                                    <Button
                                                        disabled={
                                                            pod.deliveryImagePath !== null ? false : true
                                                        }
                                                        onClick={this.download}
                                                        data-deliveryNo={pod.deliveryNo}
                                                        data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK}
                                                        data-pod={pod.deliveryImagePath}
                                                        type="button"
                                                        className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white"
                                                    >
                                                        <i className="fas fa-download"></i>
                                                    </Button>
                                                </div>
                                                {/* <small className="form-text text-muted w3-text-red font-weight-bold">Note: PDF files less than 5mb allowed.</small> */}
                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>LR Back</label> <br />
                                                <div className="input-group-append">
                                                    <Button disabled={pod.deliveryBackImagePath !== null ? false : true} onClick={this.view} data-key="podView"
                                                        data-deliveryNo={pod.deliveryNo} data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK} data-pod={pod.deliveryBackImagePath} className="w3-button w3-round w3-tiny w3-white w3-hover-text-green w3-text-green w3-border w3-hover-white"><i className="fas fa-eye" /></Button>
                                                    <ReactFileReader base64={true} fileTypes={[".pdf"]} handleFiles={(files) => { this.handleFiles(files, "deliveryBackImage") }}>
                                                        <Button type="button" className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white">
                                                            <i className="fas fa-upload"></i>
                                                        </Button>
                                                    </ReactFileReader>
                                                    <Button
                                                        disabled={
                                                            pod.deliveryBackImagePath !== null ? false : true
                                                        }
                                                        onClick={this.download}
                                                        data-deliveryNo={pod.deliveryNo}
                                                        data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK}
                                                        data-pod={pod.deliveryBackImagePath}
                                                        type="button"
                                                        className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white"
                                                    >
                                                        <i className="fas fa-download"></i>
                                                    </Button>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    <Divider horizontal>
                                        <label className="p-bold-600 w3-text-blue">Invoices & Images</label>
                                    </Divider>
                                    <Grid columns="4" padded>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <label>Goods Invoice</label> <br />
                                                <div className="input-group-append ">
                                                    <Button disabled={pod.customerInvoicePath !== null ? false : true} onClick={this.view} data-deliveryNo={pod.deliveryNo} data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK} data-pod={pod.customerInvoicePath} className="w3-button w3-round w3-tiny w3-border w3-white w3-hover-text-green w3-text-green w3-hover-white"><i className="fas fa-eye" /></Button>
                                                    <span>
                                                        <ReactFileReader base64={true} fileTypes={[".pdf"]} data-key="test" handleFiles={(files) => { this.handleFiles(files, "customerInvoice") }}>
                                                            <Button type="button" data-key="test" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white">
                                                                <i className="fas fa-upload"></i>
                                                            </Button>
                                                        </ReactFileReader>
                                                    </span>
                                                    <Button
                                                        disabled={
                                                            pod.customerInvoicePath !== null ? false : true
                                                        }
                                                        onClick={this.download}
                                                        data-deliveryNo={pod.deliveryNo}
                                                        data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK}
                                                        data-pod={pod.customerInvoicePath}
                                                        type="button"
                                                        className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white"
                                                    >
                                                        <i className="fas fa-download"></i>
                                                    </Button>
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Vendor Invoice</label> <br />
                                                <div className="input-group-append ">
                                                    <Button disabled={pod.vendorInvoicePath !== null ? false : true} onClick={this.view} data-deliveryNo={pod.deliveryNo} data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK} data-pod={pod.vendorInvoicePath} className="w3-button w3-round w3-tiny w3-border w3-white w3-hover-text-green w3-text-green w3-hover-white"><i className="fas fa-eye" /></Button>
                                                    <span>
                                                        <ReactFileReader base64={true} fileTypes={[".pdf"]} handleFiles={(files) => { this.handleFiles(files, "vendorInvoice") }}>
                                                            <Button type="button" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white">
                                                                <i className="fas fa-upload"></i>
                                                            </Button>
                                                        </ReactFileReader>
                                                    </span>
                                                    <Button
                                                        disabled={
                                                            pod.vendorInvoicePath !== null ? false : true
                                                        }
                                                        onClick={this.download}
                                                        data-deliveryNo={pod.deliveryNo}
                                                        data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK}
                                                        data-pod={pod.vendorInvoicePath}
                                                        type="button"
                                                        className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white"
                                                    >
                                                        <i className="fas fa-download"></i>
                                                    </Button>
                                                </div>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Data Logger</label> <br />
                                                <div className="input-group-append ">
                                                    <Button disabled={pod.dataLoggerPath !== null ? false : true} onClick={this.view} data-deliveryNo={pod.deliveryNo} data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK} data-pod={pod.dataLoggerPath} className="w3-button w3-round w3-tiny w3-border w3-white w3-hover-text-green w3-text-green w3-hover-white"><i className="fas fa-eye" /></Button>
                                                    <span>
                                                        <ReactFileReader base64={true} fileTypes={[".pdf"]} handleFiles={(files) => { this.handleFiles(files, "dataLogger") }}>
                                                            <Button type="button" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white">
                                                                <i className="fas fa-upload"></i>
                                                            </Button>
                                                        </ReactFileReader>
                                                    </span>
                                                    <Button
                                                        disabled={
                                                            pod.dataLoggerPath !== null ? false : true
                                                        }
                                                        onClick={this.download}
                                                        data-deliveryNo={pod.deliveryNo}
                                                        data-orderNo={pod.orderNo}
                                                        data-RAK={pod.RAK}
                                                        data-pod={pod.dataLoggerPath}
                                                        type="button"
                                                        className="w3-button w3-round w3-tiny w3-white p-hover w3-border w3-hover-text-blue w3-text-blue w3-hover-white"
                                                    >
                                                        <i className="fas fa-download"></i>
                                                    </Button>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <label>Shipment Image</label> <br />
                                                <ReactFileReader base64={true} fileTypes={[".png", ".jpg", ".jpeg"]} handleFiles={(files) => { this.handleFiles(files, "shipmentImage") }}>
                                                    <Button type="button" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white mb-1">
                                                        <i className="fas fa-upload"> Replace</i>
                                                    </Button>
                                                </ReactFileReader>
                                                {/* <img alt="ship" width="50%" src={pod.shipmentImagePath !== null ? `${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem('customerNumber')}&deliveryNumber=${pod.deliveryNo}&orderNo=${pod.orderNo}&resource_url=${pod.shipmentImagePath}&rak=${pod.RAK}` : defaultImage} /> */}
                                                <Image alt="ship" width="50%" src={pod.shipmentImagePath !== null ? `${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem('customerNumber')}&deliveryNumber=${pod.deliveryNo}&orderNo=${pod.orderNo}&resource_url=${pod.shipmentImagePath}&rak=${pod.RAK}` : defaultImage} size='medium' bordered />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Recipient Image</label> <br />
                                                <ReactFileReader base64={true} fileTypes={[".png", ".jpg", ".jpeg"]} handleFiles={(files) => { this.handleFiles(files, "recipientImage") }}>
                                                    <Button type="button" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white mb-1">
                                                        <i className="fas fa-upload"> Replace</i>
                                                    </Button>
                                                </ReactFileReader>
                                                <Image alt="recipient" size="medium" bordered width="50%" src={pod.recipientImagePath !== null ? `${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem('customerNumber')}&deliveryNumber=${pod.deliveryNo}&orderNo=${pod.orderNo}&resource_url=${pod.recipientImagePath}&rak=${pod.RAK}` : defaultImage} />

                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Signature</label> <br />
                                                <ReactFileReader base64={true} fileTypes={[".png", ".jpg", ".jpeg"]} handleFiles={(files) => { this.handleFiles(files, "signatureImage") }}>
                                                    <Button type="button" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white mb-1">
                                                        <i className="fas fa-upload"> Replace</i>
                                                    </Button>
                                                </ReactFileReader>
                                                <Image alt="signature" size="medium" bordered width="50%" src={pod.signatureImagePath !== null ? `${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem('customerNumber')}&deliveryNumber=${pod.deliveryNo}&orderNo=${pod.orderNo}&resource_url=${pod.signatureImagePath}&rak=${pod.RAK}` : defaultImage} />

                                            </Grid.Column>
                                            <Grid.Column>
                                                <label>Delivery Agent Image</label> <br />
                                                <ReactFileReader base64={true} fileTypes={[".png", ".jpg", ".jpeg"]} handleFiles={(files) => { this.handleFiles(files, "deliveryAgentSelfie") }}>
                                                    <Button type="button" className="w3-button w3-border w3-round w3-tiny w3-white p-hover w3-hover-text-blue w3-text-blue w3-hover-white mb-1">
                                                        <i className="fas fa-upload"> Replace</i>
                                                    </Button>
                                                </ReactFileReader>
                                                <Image alt="agent" size="medium" bordered width="50%" src={pod.deliveryAgentSelfiePath !== null ? `${process.env.REACT_APP_BASE_COMMON}/pod/podDetails/secure/resource?customerNumber=${localStorage.getItem('customerNumber')}&deliveryNumber=${pod.deliveryNo}&orderNo=${pod.orderNo}&resource_url=${pod.deliveryAgentSelfiePath}&rak=${pod.RAK}` : defaultImage} />

                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    <Divider horizontal>
                                        <label className="p-bold-600 w3-text-blue">Other Details</label>
                                    </Divider>
                                    <Grid columns="2" padded>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <label>Shortage Quantity</label> <br />
                                                <div className="field">
                                                    <div className="ui input">
                                                        <input type="number" min="0" value={this.state.shortageQuantity} name="shortageQuantity" onChange={this.handleChange} />
                                                    </div>
                                                    {this.state.shortageQuantity !== pod.shortageQuantity ? <button onClick={this.upload} data-key="shortageQuantity" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                        <i className="fas fa-check"></i>
                                                    </button> : ''}
                                                </div></Grid.Column>
                                            <Grid.Column>
                                                {/* {console.log('>>>', values.shortageReason)} */}
                                                <label>Shortage Reason</label> <br />
                                                <Dropdown
                                                    selection
                                                    defaultValue={this.state.shortageReason}
                                                    loading={options.length < 0 ? true : false}
                                                    options={options}
                                                    onChange={this.handleDropdown}
                                                    name="shortageReason"
                                                />
                                                {this.state.shortageReason !== pod.shortageReasonId ? <button onClick={this.upload} data-key="shortageReason" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                    <i className="fas fa-check"></i>
                                                </button> : ''}</Grid.Column>
                                            <Grid.Column>
                                                <label>Damage Quantity</label> <br />
                                                <div className="field">
                                                    <div className="ui input">
                                                        <input type="number" value={this.state.damageQuantity} min="0" name="damageQuantity" onChange={this.handleChange} />
                                                    </div>
                                                    {this.state.damageQuantity !== pod.damageQuantity ? <button onClick={this.upload} data-key="damageQuantity" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                        <i className="fas fa-check"></i>
                                                    </button> : ''}
                                                </div> </Grid.Column>
                                            <Grid.Column>
                                                <label>Damage Reason</label> <br />
                                                <Dropdown
                                                    selection
                                                    defaultValue={this.state.damageReason}
                                                    loading={options.length < 0 ? true : false}
                                                    options={options}
                                                    name="damageReason"
                                                    onChange={this.handleDropdown}
                                                />
                                                {this.state.damageReason !== pod.damageReasonId ? <button onClick={this.upload} data-key="damageReason" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                    <i className="fas fa-check"></i>
                                                </button> : ''}</Grid.Column>
                                            <Grid.Column>
                                                <label>Excess Quantity</label> <br />
                                                <div className="field">
                                                    <div className="ui input">
                                                        <input type="number" min="0" value={this.state.excessQuantity} name="excessQuantity" onChange={this.handleChange} />
                                                    </div>
                                                    {this.state.excessQuantity !== pod.excessQuantity ? <button onClick={this.upload} data-key="excessQuantity" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                        <i className="fas fa-check"></i>
                                                    </button> : ''}
                                                </div></Grid.Column>
                                            <Grid.Column>
                                                <label>Reason</label> <br />
                                                <Dropdown
                                                    selection
                                                    defaultValue={this.state.excessReason}
                                                    loading={options.length < 0 ? true : false}
                                                    options={options}
                                                    name="excessReason"
                                                    onChange={this.handleDropdown}
                                                />

                                                {+this.state.excessReason !== +pod.excessReasonId ? <button onClick={this.upload} data-key="excessReason" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                    <i className="fas fa-check"></i>
                                                </button> : ''}</Grid.Column>
                                            <Grid.Column columns="4">
                                                <label>Notes</label> <br />
                                                <TextArea rows="2" value={this.state.delivery_reason} onChange={this.handleChange} className="form-control" name="deliveryNotes"></TextArea>
                                                {this.state.delivery_reason !== pod.deliveryNotes ? <button onClick={this.upload} data-key="deliveryNotes" data-id={pod.deliveryDetailId} data-delivery={pod.deliveryNo} data-order={pod.orderNo} className="btn border">
                                                    <i className="fas fa-check"></i>
                                                </button> : ''}</Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </>

                            ))}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <button type="button" onClick={this.props.viewPodModalClose} className="w3-button w3-round w3-tiny w3-light-grey w3-hover-text-white w3-hover-grey ml-1 ">
                            Close</button>
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}
